// Validates name characters (default: letters, spaces, and hyphens - can be passed other RegEx)
import { ValidatorFn, AbstractControl } from '@angular/forms';

export function nameCharactersValidator(pattern: RegExp = /^[a-zA-Z -.']*$/): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const test = pattern.test(control.value);
    return test ? null : {nameCharacters: {value: control.value}};
  };
}
